import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const AList: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--aList')}
    data-icon={icon}
    width="46"
    height="46"
    viewBox="0 0 46 46"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-287.000000, -31.000000)">
        <g id="A-List" transform="translate(287.000000, 31.000000)">
          <circle
            id="Oval-4"
            fill="#AB2434"
            cx="22.7809524"
            cy="22.7809524"
            r="22.7809524"
          />
          <text
            id="A"
            fontFamily="ExpressSans-Regular, ExpressSans"
            fontSize="18.48"
            fontWeight="normal"
            letterSpacing="1.78639995"
            fill="#FFFFFF"
          >
            <tspan x="16.2921276" y="27.4650789">
              A
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
);

export default AList;
